export enum TeacherPageEvents{
    //signin
    USER_SIGN_IN_SUCCESS= "user_sign_in_success",

    //switch
    TEACHER_APP_HOMEWORK_TEACH_BUTTON_CLICKED = "teacher_app_homework_teach_button_clicked",
    TEACHER_APP_HOMEWORK_MANAGE_BUTTON_CLICKED = "teacher_app_homework_manage_button_clicked",


    //class work 
    TEACHER_APP_HOMEWORK_PAGE_BUTTON_CLICKED = "teacher_app_homework_page_button_clicked",
    TEACHER_APP_HOMEWORK_PAGE_ADD_DIARY_BUTTON_CLICKED = "teacher_app_homework_page_add_diary_button_clicked",
    TEACHER_APP_HOMEWORK_PAGE_CLASSWORK_BUTTON_CLICKED = "teacher_app_homework_page_class_work_button_clicked",
    TEACHER_APP_HOMEWORK_PAGE_CLASSWORK_CLASS_CLICKED = "teacher_app_homework_page_class_work_class_clicked",
    TEACHER_APP_HOMEWORK_PAGE_CLASSWORK_DATE_CLICKED = "teacher_app_homework_page_class_work_date_clicked",
    TEACHER_APP_HOMEWORK_PAGE_CLASSWORK_ADD_ICON_CLICKED = "teacher_app_homework_page_class_work_add_icon_clicked",
    TEACHER_APP_HOMEWORK_PAGE_CLASSWORK_EDIT_BUTTON_CLICKED = "teacher_app_homework_page_class_work_edit_button_clicked",
    TEACHER_APP_HOMEWORK_PAGE_CLASSWORK_SUBMIT_BUTTON_CLICKED = "teacher_app_homework_page_class_work_submit_button_clicked",
    TEACHER_APP_HOMEWORK_PAGE_CLASSWORK_UPLOADED_SUCCESS = "teacher_app_homework_page_class_work_uploaded_success",
    TEACHER_APP_HOMEWORK_PAGE_CLASSWORK_CLOSE_ICON_CLICKED = "teacher_app_homework_page_class_work_close_icon_clicked",
    TEACHER_APP_HOMEWORK_PAGE_CLASSWORK_BACK_ICON_CLICKED ="teacher_app_homework_page_class_work_back_icon_clicked",

    //homework
    TEACHER_APP_HOMEWORK_PAGE_HOME_WORK_BUTTON_CLICKED = "teacher_app_homework_page_home_work_button_clicked",
    TEACHER_APP_HOMEWORK_PAGE_HOME_WORK_CLASS_CLICKED = "teacher_app_homework_page_home_work_class_clicked",
    TEACHER_APP_HOMEWORK_PAGE_HOME_WORK_DATE_CLICKED = "teacher_app_homework_page_home_work_date_clicked",
    TEACHER_APP_HOMEWORK_PAGE_HOME_WORK_ADD_ICON_CLICKED = "teacher_app_homework_page_home_work_add_icon_clicked",
    TEACHER_APP_HOMEWORK_PAGE_HOME_WORK_EDIT_BUTTON_CLICKED = "teacher_app_homework_page_home_work_edit_button_clicked",
    TEACHER_APP_HOMEWORK_PAGE_HOME_WORK_SUBMIT_BUTTON_CLICKED = "teacher_app_homework_page_home_work_submit_button_clicked",
    TEACHER_APP_HOMEWORK_PAGE_HOME_WORK_UPLOADED_SUCCESS = "teacher_app_homework_page_home_work_uploaded_success",
    TEACHER_APP_HOMEWORK_PAGE_HOME_WORK_CLOSE_ICON_CLICKED = "teacher_app_homework_page_home_work_close_icon_clicked",
    TEACHER_APP_HOMEWORK_PAGE_VIEW_CLICKED = "teacher_app_homework_page_view_clicked",

    //result
    TEACHER_APP_RESULT_CLICKED= "teacher_app_result_clicked",
    TEACHER_APP_RESULT_PAGE_CLASS_CLICKED= "teacher_app_result_page_class_clicked",
    TEACHER_APP_RESULT_PAGE_ALL_CLICK= "teacher_app_result_page_all_click",
    TEACHER_APP_RESULT_PAGE_SUBJECT_CLICK= "teacher_app_result_page_subject_click",
    TEACHER_APP_RESULT_PAGE_ADD_ICON_CLICK= "teacher_app_result_page_add_icon_click",
    TEACHER_APP_RESULT_PAGE_CANCEL_BUTTON_CLICK= "teacher_app_result_page_cancel_button_click",
    TEACHER_APP_RESULT_PAGE_NEXT_BUTTON_CLICK= "teacher_app_result_page_next_button_click",

    //doubts
    TEACHER_APP_DOUBTS_CLICKED= "teacher_app_doubts_clicked",
    TEACHER_APP_DOUBTS_PAGE_REPLY_BUTTON_CLICK= "teacher_app_doubts_page_reply_button_click",
    TEACHER_APP_DOUBTS_PAGE_CANCEL_BUTTON_CLICK= "teacher_app_doubts_page_cancel_button_click",
    TEACHER_APP_DOUBTS_PAGE_SEND_BUTTON_CLICK= "teacher_app_doubts_page_send_button_click",
    TEACHER_APP_DOUBTS_PAGE_MESSAGE_SEND_SUCCESS= "teacher_app_doubts_page_message_send_success",

    //logout
    TEACHER_APP_HOME_PAGE_NAME_ICON_CLICKED= "teacher_app_home_page_name_icon_clicked",
    TEACHER_APP_HOME_PAGE_LOGOUT_SUCCESS= "teacher_app_home_page_logout_success",
    
    //teacher
    TEACHERS_APP_STUDENTS_CLICKED = "teachers_app_students_clicked",
    TEACHERS_APP_STUDENTS_PAGE_ADD_ICON_CLICK = "teachers_app_students_page_add_icon_click",
    TEACHERS_APP_STUDENTS_PAGE_SUBMIT_BUTTON_CLICK = "teachers_app_students_page_submit_button_click",
    TEACHERS_APP_STUDENTS_PAGE_STUDENT_ADDED_SUCCESS = "teachers_app_students_page_student_added_success",
    TEACHERS_APP_STUDENTS_PAGE_MESSAGE_ICON_CLICK = "teachers_app_students_page_message_icon_click",
    TEACHERS_APP_STUDENTS_PAGE_CANCEL_BUTTON_CLICK = "teachers_app_students_page_cancel_button_click",
    TEACHERS_APP_STUDENTS_PAGE_UPDATE_BUTTON_CLICK = "teachers_app_students_page_update_button_click",
    TEACHERS_APP_STUDENTS_PAGE_CANCEL_ICON_CLICK = "teachers_app_students_page_cancel_icon_click",
    TEACHERS_APP_STUDENTS_PAGE_BACK_ICON_CLICK = "teachers_app_students_page_back_icon_click",


}
  